<div *ngIf="data; else loading" class="table-responsive gung-responsive">
  <table class="table">
    <thead>
      <tr>
        <th><span translate>ID</span>/<span translate>STATUS</span></th>
        <th translate>ORDER_ID</th>
        <th translate>DATE_CREATED</th>
        <th translate>CUSTOMER</th>
        <th translate>ASSIGN_TO</th>
        <th style="min-width: 50px"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of data">
      <ng-container *ngIf="{ note: item.comments[item.comments.length - 1]?.comment } as row">
      <!-- The whole row opens the claim: only the id cell used to, and nothing said so. -->
      <tr class="claim-row" [class.has-note]="!!row.note" (click)="openViewModal(item)" [title]="'OPEN' | translate">
        <td [attr.data-label]="('ID' | translate) + '/' + ('STATUS' | translate)">
          <button type="button" class="btn btn-link d-block text-center m-0 p-0 w-100">{{ item.id }}</button>
          <span
            class="badge badge-pill badge badge-light w-100"
            [style.background-color]="claimStatusColor(item.status)"
            translate
            >{{ claimStatusName(item.status) }}</span
          >
        </td>
        <td [attr.data-label]="'ORDER_ID' | translate">
          {{ item.orderId }}
        </td>
        <td [attr.data-label]="'DATE_CREATED' | translate">
          {{ item.date | date: dateUtilService.dateFormat }}
        </td>
        <td [attr.data-label]="'CUSTOMER' | translate">
          <b>{{ item.customerId }}</b>
          <br>{{ item.customerName }}</td>
        <td [attr.data-label]="'ASSIGN_TO' | translate">
          {{ item.assignTo }}
        </td>
        <td [attr.data-label]="''" class="text-nowrap" (click)="$event.stopPropagation()">
          <button *ngIf="isAdmin && !customerView" type="button" class="btn btn-sm btn-outline-primary mr-2 mb-1" (click)="openViewModal(item)">
            <i class="fas fa-edit mr-1"></i><span translate>EDIT_CLAIM</span>
          </button>
          <button *ngIf="isAdmin && !customerView" type="button" class="btn btn-sm btn-danger mr-2 mb-1" (click)="deleteOrderServices(item)">
            <i class="fas fa-trash mr-1"></i><span translate>DELETE_CLAIM</span>
          </button>
          <button *ngIf="isAdmin && !customerView" type="button" [disabled]="!!item.orderId" class="btn btn-sm btn-outline-primary mr-2 mb-1" title="{{'CREATE_RETURN_ORDER_IN_ERP' | translate}}" (click)="createReturnOrder(item)">
            <i class="fa-solid fa-file-invoice mr-1"></i><span translate>CREATE_RETURN_ORDER</span>
          </button>
          <button *ngIf="(isUser && !isAdmin) || customerView" type="button" class="btn btn-sm btn-outline-primary mr-2 mb-1" (click)="openViewModal(item)">
            <i class="fa-solid fa-eye mr-1"></i><span translate>VIEW_CLAIM</span>
          </button>
        </td>
      </tr>
      <tr *ngIf="row.note" class="claim-row note-row" (click)="openViewModal(item)">
        <td colspan="6" [attr.data-label]="'NOTE' | translate">
          <div class="claim-note" [title]="row.note">
            <i class="fa-regular fa-comment mr-1"></i><span translate class="font-weight-bold">NOTE</span>: {{ row.note }}
          </div>
        </td>
      </tr>
      </ng-container>
      </ng-container>
    </tbody>
  </table>
</div>

<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-7x"></i>
  LOADING...
</ng-template>
